import { useField } from "formik"
import { makeStyles } from "tss-react/mui"
import { Box, Divider, Typography } from "@mui/material"
import { useDateTime } from "../../../../../../../modules/localization/useDateTime"
import { DeliveryWithCart, DynamicConfigKey } from "../../../form/formTypes"
import { MAX_DELIVERIES } from "../helpers"

const useStyles = makeStyles()((theme) => ({
    active: {
        flex: "none",
        background: theme.palette.tailwind.blue[200],
        color: theme.palette.tailwind.blue[900],
        padding: "0.5rem 1rem",
        borderRadius: "5.5rem",
        cursor: "pointer",
    },
    timeBox: {
        color: theme.palette.text.secondary,
        padding: ".5rem",
        cursor: "pointer",
    },
}))

type DeliveryTimeDisplayProps = {}

export function DeliveryTimeDisplay({}: DeliveryTimeDisplayProps) {
    const { classes, cx } = useStyles()
    const dateTimeFactory = useDateTime()

    const [{ value: deliveryTimes }] = useField<DeliveryWithCart[]>(
        `${DynamicConfigKey.MULTIPLE_DELIVERIES}.deliveryTimes`,
    )
    const [{ value: deliveryDate }] = useField<string | null>(`${DynamicConfigKey.MULTIPLE_DELIVERIES}.deliveryDate`)
    const [{ value: activeTime }, , activeTimeHelpers] = useField<string | null>(
        `${DynamicConfigKey.MULTIPLE_DELIVERIES}.activeTime`,
    )

    if (deliveryTimes.length === 0 || !deliveryDate) return null

    const formattedDate = dateTimeFactory.fromISO(deliveryDate).toFormat("d MMMM")

    const selectedFirstItem = deliveryTimes[0].time || ""

    const handleTimeClick = (time: string) => {
        activeTimeHelpers.setValue(time)
    }

    const isActive = (time: string) => time === activeTime

    return (
        <>
            <Box display="flex" alignItems="center" gap=".5rem">
                <Typography
                    variant="subtitle1"
                    className={cx(isActive(selectedFirstItem) ? classes.active : classes.timeBox)}
                    onClick={() => handleTimeClick(selectedFirstItem)}
                >
                    {formattedDate}, {dateTimeFactory.fromHourMinute(selectedFirstItem).toFormat("t")}
                </Typography>
                {!isActive(selectedFirstItem) && <Divider orientation="vertical" flexItem />}
            </Box>

            {deliveryTimes.slice(1).map((delivery, index, arr) => {
                const isLast = index === arr.length - 1 && deliveryTimes.length === MAX_DELIVERIES

                const time = delivery.time || ""

                return (
                    <Box key={index} display="flex" alignItems="center" gap=".5rem">
                        <Typography
                            variant="body1"
                            className={cx(isActive(time) ? classes.active : classes.timeBox)}
                            onClick={() => handleTimeClick(time)}
                        >
                            {dateTimeFactory.fromHourMinute(time).toFormat("t")}
                        </Typography>
                        {!isLast && <Divider orientation="vertical" flexItem />}
                    </Box>
                )
            })}
        </>
    )
}
